import src from "IMAGE";
export default { src, width: 320, height: 96, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/ACBFSrodTD7yJicj8i4wMPIsLi7yHB0e8hocHPIhKCq/ACZCSbouPzvyJSUh8jU3N/JCRETyMzQ18jg6OvIrMjS/5NMXTQlOLLcAAAAASUVORK5CYII="};
